import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRacion = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'racion',
        name: 'Ración',
        component: ViewRacion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
